import Http from './http';

const http = new Http({
  productionApi: 'https://yw.zberp.net/erp-yw/',
  developmentApi: 'http://testyw.zberp.net/erp-yw/',
});

export default {
  // 查询地图各省门店数量,平台门店总数，top10取前10个省的
  queryMapProvinceShopsNum: (params) => http.post(`/portalData/queryMapProvinceShopsNum`, params),
  // 支付方式占比,和支付类型占比top1的省
  queryYearPayTypeRateTop: (params) => http.post(`/portalData/queryYearPayTypeRateTop`, params),
  // 大屏销售明细
  queryYearSaleDetail: (params) => http.post(`/portalData/queryYearSaleDetail`, params),
  // 查询 销售，成交，会员数据
  queryYearSaleOrderCustTrend: (params) => http.post(`/portalData/queryYearSaleOrderCustTrend`, params),
  // 门店年增长趋势
  queryYearShopTrend: (params) => http.post(`/portalData/queryYearShopTrend`, params),
  // 查询各省平均库存量top，各省平均铺货成本top
  queryYearStockCostTop: (params) => http.post(`/portalData/queryYearStockCostTop`, params),
  // 大屏新增门店效果返回
  getVirtualAddNum: (params) => http.post(`/portalData/getVirtualAddNum`, params),
  // 大屏支付方式明细
  queryYearPayDetail: (params) => http.post(`/portalData/queryYearPayDetail`, params),
  // 大屏当天统计结果返回（单金额，会员数量，成交件数）
  getPortalSaleSummary: (params) => http.post(`/portalData/getPortalSaleSummary`, params),
  // 大屏新增单据效果返回（地图上）
  getSheetAddAmount: (params) => http.post(`/portalData/getSheetAddAmount`, params),
  // IP白名单验证
  checkIp: (params) => http.post(`/wip/checkIp`, params),
};
